import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { Router } from "react-router-dom";
import history from "./history";
import { Provider } from "react-redux";
import { store } from "./modules/store";
import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
